import { Component, OnInit } from '@angular/core';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'smartt-bot',
    templateUrl: 'smartt-bot.component.html',
    styleUrls: ['./smartt-bot.component.scss']
})

export class SmarttBot implements OnInit {
    public isNewBrand: boolean = environment.isNewBrand

    constructor() {
        //
     }

    ngOnInit() {
        //
     }
}
